export default __webpack_public_path__ + "static/media/DFSM.1cedf518.png";